module.exports = __webpack_public_path__ + "static/media/shield-alt.5c88953d.svg";